import { render, staticRenderFns } from "./MatchMultipleProductPrincipalAccordionTable.vue?vue&type=template&id=e3d2bf4c&scoped=true&"
import script from "./MatchMultipleProductPrincipalAccordionTable.vue?vue&type=script&lang=ts&"
export * from "./MatchMultipleProductPrincipalAccordionTable.vue?vue&type=script&lang=ts&"
import style0 from "./MatchMultipleProductPrincipalAccordionTable.vue?vue&type=style&index=0&id=e3d2bf4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d2bf4c",
  null
  
)

export default component.exports